<template>
	<button
		v-if="remoteVersion"
		type="button"
		class="version-update-pill"
		:title="`Aktuell: v${currentVersion} → Neu: v${remoteVersion}`"
		@click="hardReload">
		<Info :size="14" />
		<span class="version-update-pill__text">
			Neue Version verfügbar, <span class="font-bold underline">HIER klicken</span>!
		</span>
	</button>
</template>

<script setup lang="ts">
	import { Info } from 'lucide-vue-next'
	import { currentVersion, remoteVersion, hardReload } from '@/libs/versionChecker'
</script>

<style scoped>
	@reference '@/styles/tailwind.css';

	.version-update-pill {
		@apply bg-error text-error-content inline-flex items-center gap-1.5 rounded-full px-3 py-1 text-xs font-normal transition-colors hover:bg-error/90;
	}

	.version-update-pill__text {
		@apply leading-none;
	}
</style>
